import { TRAINING_STATUS_LABELS, TrainingStatusCode } from "../../../api/training/Training.typed";

export type TrainingStatusChipColor = "warning" | "danger" | "primary" | "success" | "neutral";

const STATUS_CHIP_COLORS: Record<TrainingStatusCode, TrainingStatusChipColor> = {
  [TrainingStatusCode.InProgress]: "warning",
  [TrainingStatusCode.Done]: "primary",
  [TrainingStatusCode.Validated]: "success",
  [TrainingStatusCode.Cancelled]: "danger",
};

const STATUS_LABEL_TO_CODE: Record<string, TrainingStatusCode> = Object.fromEntries(
  Object.entries(TRAINING_STATUS_LABELS).map(([code, label]) => [label, Number(code)]),
) as Record<string, TrainingStatusCode>;

// Status may come as a numeric code or a label ("Terminé"); normalize to the numeric code.
export function resolveTrainingStatusCode(status: string | number | undefined): number {
  if (typeof status === "number") return status;
  const label = String(status ?? "");

  return STATUS_LABEL_TO_CODE[label] ?? parseInt(label, 10);
}

export function resolveTrainingStatusChip(status: string | number | undefined): {
  label: string;
  color: TrainingStatusChipColor;
} {
  const code = resolveTrainingStatusCode(status) as TrainingStatusCode;

  return {
    label: TRAINING_STATUS_LABELS[code] ?? String(status ?? "—"),
    color: STATUS_CHIP_COLORS[code] ?? "neutral",
  };
}
